import { render } from "./ProvinceTaskForm.vue?vue&type=template&id=688484e6&scoped=true&ts=true"
import script from "./ProvinceTaskForm.ts?vue&type=script&lang=ts"
export * from "./ProvinceTaskForm.ts?vue&type=script&lang=ts"

import "./ProvinceTaskForm.scss?vue&type=style&index=0&id=688484e6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688484e6"]])

export default __exports__